document.addEventListener("DOMContentLoaded", function () {

  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  gsap.registerPlugin(ScrollTrigger);

  const sections = document.querySelectorAll(".fill-text-section");

  sections.forEach(section => {

    const heading = section.querySelector(".fill-text-heading");
    const description = section.querySelector(".fill-text-description");
    const overlay = section.querySelector(".fill-text-overlay");

    if (!heading) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top center",
        end: "bottom+=200 bottom",
        scrub: 3
      }
    });

    if (overlay) {
      tl.to(overlay, {
        opacity: 0,
        ease: "none",
        duration: 3
      }, 0);
    }

    tl.to(heading, {
      backgroundPosition: "0% 0%",
      ease: "power3.out",
      duration: 4.5
    }, 0);

    if (description) {

      gsap.set(description, {
        y: 60,
        opacity: 0,
        filter: "blur(10px)"
      });

      tl.to(description, {
        y: 0,
        opacity: 1,
        filter: "blur(0px)",
        ease: "power3.out",
        duration: 3.5
      }, 2.5);
    }

  });

});